export default __webpack_public_path__ + "static/media/25t.80a0b2d8.jpg";